<div *ngIf="showReminder" class="docs-reminder d-flex justify-content-between gap-3 bg-white">
  <div class="docs-reminder__body d-flex align-items-center gap-3">
    <div class="docs-reminder__icon-wrap">
        <i class="bi bi-exclamation-triangle-fill icon"></i>
    </div>

    <div class="docs-reminder__header">
      <h6 class="docs-reminder__title mb-1">Action Required: Upload Verification Documents</h6>
      <p class="docs-reminder__subtitle mb-0">
        You have uploaded <b>{{ uploadedDocumentCount }}</b> of <b>{{ totalDocumentCount }}</b> verification documents.
        Please upload the remaining documents to unlock full access to all platform features.
      </p>
    </div>
  </div>

  <div class="docs-reminder__actions">
    <a routerLink="/profile" fragment="verification" class="anq-btn anq-btn-secondary">
      Upload Documents <i class="bi bi-arrow-right"></i>
    </a>
  </div>

</div>
